'use strict';

exports.__esModule = true;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.getExplore = getExplore;
exports.getVenue = getVenue;

var _apiClient = require('../../network/api-client');

var _apiClient2 = _interopRequireDefault(_apiClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var API = {
  CUSTOMER_VENUES_EXPLORE: '/customer/venues/explore',
  CUSTOMER_VENUES: '/customer/venues'

  /**
   * Wrapper for `/customer/venues/explore` API endpoint
   */

};var venues = {
  getExplore: getExplore,
  getVenue: getVenue
};

exports.default = venues;

/**
 * Get all explore venues
 * @returns {promise} containing venues
 */

function getExplore(_ref) {
  var params = _ref.params;

  return _apiClient2.default.get({ route: API.CUSTOMER_VENUES_EXPLORE, params: params });
}

/**
 * Get venue by venueId
 * @param {Object} attrs - Attributes
 * @param {integer} [attrs.venueId] - Venue ID - required
 * @returns {promise} containing the venue
 */
function getVenue(attrs) {
  var venueId = attrs.venueId,
      others = (0, _objectWithoutProperties3.default)(attrs, ['venueId']);

  return _apiClient2.default.get({ route: API.CUSTOMER_VENUES + '/' + venueId, params: (0, _extends3.default)({}, others) });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/customer/venues/venues.js
// module id = 1093
// module chunks = 0